import { ADICIONAR_FILTRO_USUARIO, LIMPAR_FILTRO_USUARIO, LISTAR_FILTROS_USUARIO, REMOVER_FILTRO_USUARIO } from '../../actions/types'
import { filtroExiste } from '../../util/filtros'

const initialState = undefined

const initial = {
}

export const filtrosAdicionadosUsuarios = (state = [], action = initialState) => {
  switch (action.type) {
    case ADICIONAR_FILTRO_USUARIO: {
      if (!filtroExiste(state, action.payload)) {
        return state.concat(action.payload)
      }
      return state
    }

    case REMOVER_FILTRO_USUARIO: {
      const copia = [...state]
      return copia.filter(filtro => filtro.chave !== action.payload.chave || filtro.valor !== action.payload.valor)
    }

    case LIMPAR_FILTRO_USUARIO: {
      return []
    }

    default:
      return state
  }
}

export const filtrosUsuarios = (state = initial, action) => {
  switch (action.type) {
    case LISTAR_FILTROS_USUARIO: {
      return action.payload.data
    }
    default:
      return state
  }
}
